export default {
    // 常用词汇
    dict: {
        "000001": "SSE Composite Index",
        399001: "SZSE Component Index",
        399006: "ChiNext Index",
        510050: "SSE 50 ETF",
        510300: "CSI 300 ETF",
        159915: "ChiNext ETF",
        588000: "STAR 50 ETF",
        510500: "CSI 500 ETF",
        CN00Y: "FTSE China A50 Index",
    },
    // 公共组件
    widget: {
        underlying: {},
        ppl: {
            title: "Options Analytics Pro",
            exclusive_privileges: "Exclusive Benefits",

            cloud_storage:
                "Multi-Asset Market Overview: Track real-time OI, IV, Gamma, and Max Pain for key A-share ETFs including SSE 50, CSI 300, and STAR 50.",
            historical_analysis:
                " Intelligent Anomaly Detection: Automatically identify overnight spikes, IV surges, and OI shifts with AI-generated structural insights.",
            strategy_tools:
                "AI Market Mind: Generate daily market structure reports and engage in natural-language Q&A for strategy analysis.",
            research_reports:
                "Volatility Surface & Term Structure Analysis: Visualize market pricing sentiment and forward volatility expectations.",
            anomaly_monitoring:
                "Contract & Strategy Backtest Center: Run historical multi-contract backtests, sensitivity analyses, and receive AI-driven optimization tips.",
            member_community: "From raw data to actionable insight — let AI be your options analyst.",

            disclaimer: "Disclaimer",
            disclaimer_1: "This is a virtual service product. Purchases are non-refundable.",
            disclaimer_2:
                "This product does not constitute any investment advice. All content is for educational and research purposes only.",
            purchase: "Purchase",
            year: "year",
            original: "Original",
        },
    },
    // 首页
    overview: {
        no_data: "No trading data for this date, possibly a non-trading day.",
        news: {
            title: "News",
            more: "More",
        },
        long_short: {
            call: "Call Volume/Open Interest",
            put: "Put Volume/Open Interest",
        },
        mini_chart: {
            volatility_surface: "Volatility Surface",
            distribution: "Position Analysis",
            gamma_wall: "Gamma Wall",
        },
        notice: {
            title: "Notice",
            more: "More",
        },
        helper: {
            title: "Tips",
            helper_1:
                "Wave Point (°): A concept introduced by FSF for A-share ETF options. 1 Wave Point (1°) corresponds to 0.001 CNY.",
            helper_2:
                "Daily snapshot data is updated gradually after market close, with some data potentially delayed until after 8:00 PM.",
        },
    },
    // 归档分析
    history: {
        tabs: {
            contract_stat: "Underlying Contract Trend Statistics",
        },

        macroanalysis: "Macro Analysis",
        microanalysis: "Micro Analysis",
        contract_trend: "Contract Trend",
        underlying_trend: "Underlying Trend",

        // K-line chart related
        kline: {
            open: "Open",
            close: "Close",
            high: "High",
            low: "Low",
            amount: "Amount",
            avg: "Average",
        },
        stock_stat: {
            fluctuation: "Fluctuation points",
            kline: "K-line",
            fluctuation_points: "fluctuation points",
            positive: "positive peaks",
            negative: "negative peaks",
            point_max: "maximum peak",
            point_min: "minimum peak",
            stat: {
                positive_max: "max of positive peaks",
                negative_max: "max of negative peaks",
                positive_avg: "average of positive peaks",
                negative_avg: "average of negative peaks",
            },
            fluctuation_tip:
                "Wave Points (°): A specialized unit designed for Chinese options in this application. Taking current ETF options as an example, 1 Wave Point represents a price fluctuation of ¥0.001 in the underlying ETF.",

            iv_history: "Implied Volatility History",
        },

        contract_stat: {
            date: "Contract Date",
            code: "Underlying Code",
            name: "Underlying Name",
            contract_count: "Number of Contracts",
            turnover_million_cny: "Total Turnover (10k CNY)",
            volume: "Total Volume (Contracts)",
            call_volume: "Call Volume",
            put_volume: "Put Volume",
            put_call_ratio_pct: "Call/Put Ratio (%)",
            open_interest: "Total Open Interest",
            call_open_interest: "Call Open Interest",
            put_open_interest: "Put Open Interest",
            unit: "Contracts",
            no_data: "No trading data in the current period.",
            total: "Total",
            volume_name: "Volume",
            interest_name: "Interest",
            put_call_ratio_name: "Put/Call",
        },
        oi_trend: "OI Trend",
        oi_trend_tip: "Observe the changes in market long/short bias over time",
        volume_trend: "Volume Trend",
        volume_trend_tip:
            "Liquidity and activity indicators, peak volume days often correspond to market turning points or event-driven movements",

        // 持仓合约分布
        contract_distribution: "Interest Distribution",
        contract_distribution_title: "Distribution of {mode} in Call and Put Options",
        expiration_date: "Expiration Date",
        check_all: "Check all",
        strike_price: "Strike Price",
        call: "Call",
        put: "Put",
        distribution_mode: {
            open_interest: "Open Interest",
            oi_change: "OI Change",
            volume: "Volume",
            turnover: "Turnover",
        },

        // 排行榜
        rank: {
            title: "Ranking Board",
            all: "All",
            position_increase: "Increase",
            position_decrease: "Decrease",
            price_increase: "Gainers",
            price_decrease: "Losers",
            open_interest: "Top Open Interest",
            open_interest_tip: "Shows the key strike prices where major players hold long-term positions (trend bias)",
            volume: "Top Volume",
            volume_tip: "Highlights which contracts are most actively traded today",
            oi_change: "Top ΔOI",
            oi_change_tip: "Reflects where market attention and positioning are shifting",
            change_rate: "Top Price Movers",
            change_rate_tip: "Finds contracts with notable price swings",
            implied_volatility: "Top IV",
            implied_volatility_tip: "Identifies contracts with short-term premium opportunities",
        },

        scatter: "Trading Heatmap",
        volume_scatter: "Volume Heatmap",
        turnover_scatter: "Turnover Heatmap",
        max_pain: "Max Pain",
        delta_weighted_oi: "Delta-Weighted OI",
        dealer_gamma: "Dealer Gamma",
        expiration_month: "Expiration Month",

        gamma: {
            bias: "Bias Value",
            structure_type: "Structure Type",
            market_feature: "Market Characteristics",
            structure_type_1: "Pressure Dominated (Long Gamma)",
            market_feature_1:
                "Market makers hedge against the trend, volatility is suppressed, oscillation tends to be flat",
            structure_type_2: "Support Dominated (Short Gamma)",
            market_feature_2: "Market makers hedge with the trend, volatility is amplified, breakout is more likely",
            structure_type_3: "Neutral Structure",
            market_feature_3:
                "Balanced forces between upper and lower walls, price tends to oscillate in the middle range",
            support_title: "Support Dominated",
            pressure_title: "Pressure Dominated",
        },

        volatility: "Volatility",
        term_structure: "Term Structure",
        strike_skew: "Strike Skew",
        comprehensive: "Comprehensive",
    },
    // 实时分析
    realtime: {
        underlying: {
            open_price: "Open",
            close_price: "Prev Close",
            high_price: "High",
            low_price: "Low",
        },
        toolbar: {
            add: "Add T-Board",
            setting: "Settings",
            sort: "Sort",
            save: "Save",
            refresh: "Refresh",
            seconds: "seconds",
            auto_refresh: "Auto Refresh",
            target: "Underlying",
            target_placeholder: "Select underlying",
            expiration_date: "Expiration",
            expiration_date_placeholder: "Select expiration date",
            duplicate: "This board already exists. Please select a different underlying or expiration date.",
        },
        tboard: {
            settings_tip: "Drag to reorder fields, check to show/hide columns",
            columns_settings: "Column Settings",
            setting: "Settings",
            days: "Days",

            columns: {
                name: "Name",
                latest: "Last",
                change_rate: "Change %",
                change_amount: "Change",
                open_interest: "OI",
                volume: "Volume",
                implied_volatility: "IV",
                strike_price: "Strike",
                oi_change: "OI Change",
                theta: "Theta",
                delta: "Delta",
                vega: "Vega",
                theoretical_price: "Theoretical",
            },

            settings: {
                title: "Settings",
                column: "Columns per Row",
            },

            // Abnormal alerts
            abnormal: {
                warning: "Abnormal Alert",
                critical: "Critical Alert",
                change_rate: "Change",
                deviation: "Deviation",
                sigma: "σ",
            },
            premium_tip: {
                high: "Current price is higher than theoretical price, there is a premium of {price} yuan",
                low: "Current price is lower than theoretical price, there is a discount of {price} yuan",
            },
        },
    },
    analyze: {
        toolbar: {
            contract: "Underlying",
            search_placeholder: "Please enter the underlying code or name to search",
            clear: "Clear",
            title: "Select Contract",
            empty: "< Click to select contract >",
            select_limit: "You can select up to {num} contracts for comparison.",
            select: "Select",
            already_selected: "This contract has already been selected",
            add_disabled: "Please select an underlying first",
        },
        iv_chart_title: "HV Trend",
        price_kline_chart_title: "Price Trend",
        risk_indicators: "Risk Indicators",
        fav: "Favorites",
        empty_fav: "No favorite contracts yet",
        empty_guide: "Please select contracts to analyze",
        delete_confirm: "Are you sure to delete this contract?",
        risk: {
            vega: "Implied volatility every change of 1 percentage point, option price changes by {vega} yuan",
            delta: "Underlying price changes by 1 tick (0.001 yuan), option price changes by {delta} yuan, option exercise probability is about {delta_pct}%",
            theta: "Time decay of 1 day, option price changes by {theta} yuan",
            rho: "Risk-free rate changes by 1%, option price changes by {rho} yuan, default is 1-year government bond yield, less impact on short-term contracts",
            gamma: "Underlying price changes by 1 tick (0.001 yuan), Delta changes by about {gamma}. The larger the Gamma, the more sensitive Delta is to changes in the underlying price, usually largest when at-the-money and near expiration.",
        },
        info: {
            days_to_expiry: "Days to Expiry",
            iv: "Implied Volatility",
            prev_close: "Previous Close",
            open_price: "Open Price",
            last_price: "Last Price",
            oi_change: "Open Interest Change",
            open_interest: "Open Interest",
            overnight_gap: "Overnight Gap",
            today_change: "T+0 Change",
            days_to_expiry_tip:
                ">60 days: Time value decay is relatively slow\n60-30 days: Theta increases significantly, ATM daily Theta is about 1.3-1.5 times that at around 120 days\n30-7 days: Entering 'accelerated decay period', ATM daily Theta is roughly 1.5-3 times that at 60 days\n<7 days: Entering 'rapid decay period', ATM daily Theta is about 2-3 times that at 30 days\n<3 days: Theta amplifies non-linearly, quickly approaching zero",
        },
    },
    calc: {
        title: "Options Calculator",
        my_strategies: "My Strategies",
        type: "Type",
        option_type: {
            call: "Call Option",
            put: "Put Option",
        },
        display: {
            theoretical_price: "Theoretical Price",
            premium_rate: "Premium Rate",
        },
        greeks: {
            delta: "Delta",
            gamma: "Gamma",
            vega: "Vega",
            theta: "Theta",
            rho: "Rho",
        },
        metrics: {
            intrinsic_value: "Intrinsic Value",
            time_value: "Time Value",
            seller_annualized: "Seller Annualized",
        },
        params: {
            title: "Parameters",
            underlying: "Underlying",
            underlying_placeholder: "Select Underlying",
            spot_price: "Spot Price (S)",
            strike_price: "Strike Price (K)",
            volatility: "Volatility (σ)",
            expiry_date: "Expiry Date",
            expiry_date_placeholder: "Select Expiry Date",
            days_remaining: "{days} days remaining",
            risk_free_rate: "Risk-Free Rate (r)",
        },
        strategy: {
            title: "Strategy Analysis",
            empty: "Please enter parameters and calculate",
            annualized: {
                title: "Annualized Return Strategy",
                days: "Days to Expiry",
                days_unit: "days",
                margin: "Margin Required (CNY/Contract, Seller Only)",
                profit: "Premium Income (CNY/Contract)",
                rate: "Annualized Return",
            },
            t0: {
                title: "T+0 Strategy Returns",
                profit: "Expected P/L",
                volatility: {
                    title: "Volatility Profit",
                    change: "IV Change",
                },
                delta: {
                    title: "Delta Hedging Profit",
                    change: "Spot Price Change",
                },
                theta: {
                    title: "Theta Decay Profit",
                    days: "Time Decay",
                },
            },
        },
        strategy_list: {
            title: "Strategy List",
            underlying_code: "Underlying",
            underlying_code_placeholder: "Enter underlying code",
            option_type: "Type",
            option_type_placeholder: "Select type",
            expiry_date: "Expiry Date",
            parameters: "Parameters",
            results: "Results",
            load: "Load",
            load_failed: "Failed to load strategy list",
            delete_confirm: "Are you sure to delete this strategy?",
            price: "Price",
        },
        decay: {
            title: "Time Value Decay Curve",
            current: "Current",
            days: "d",
            remaining_days: "{day} Days Remaining",
            call_time_value: "Call Option Time Value",
            put_time_value: "Put Option Time Value",
            call_decay_percent: "Call Decay Percentage",
            put_decay_percent: "Put Decay Percentage",
            days_remaining: "Days Remaining",
            time_value: "Time Value (CNY)",
            decay_percent: "Decay Percentage (%)",
        },
    },
    trade: {
        prev: "Previous",
        latest: "Latest Trading Day",
        next: "Next",
        date_placeholder: "Please select the date",
    },
    underlying: {
        latest_price: "Latest",
        open_price: "Open",
        close_price: "Close",
        high_price: "High",
        low_price: "Low",
        avg_price: "Average",
        amplitude: "Amplitude",
        change_rate: "Change Rate",
        change_amount: "Change Amount",
        iv_index: "Implied Volatility",
        volume: "Volume",
        amount: "Turnover",
        volume_ratio: "Volume Ratio",
        buy_volume: "Buy Volume",
        sell_volume: "Sell Volume",
        sentiment_index: "Sentiment Index",
        sentiment_extreme_bullish: "Extremely Bullish",
        sentiment_extreme_bearish: "Extremely Bearish",
        sentiment_mild_bullish: "Mildly Bullish",
        sentiment_mild_bearish: "Mildly Bearish",
        sentiment_neutral: "Neutral",
        total_oi: "Total Open Interest",
        max_pain: "Max Pain",
        open: "Open",
        close: "Prev Close",
    },
};
